import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../layouts/PageTitle";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  fetchSmtpSettings,
} from "../../../store/custom-actions/settings-actions/smtp/GetSmtpSettingsSlicer";
import {
  updateSmtpSettings,
} from "../../../store/custom-actions/settings-actions/smtp/PostSmtpSettingsSlicer";
import SubmitButton from "../../components/ui/SubmitButton";
import FormField from "../../components/ui/FormField";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
function SmtpSettingsForm() {
  const { t } = useTranslation();
  const { loading: fetchLoading, data: settingData } = useSelector(
    (state) => state.getSmtpSettingsSlicer
  );
  const { loading: submitLoading } = useSelector(
    (state) => state.postSmtpSettingsSlicer
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const smtpFields = useMemo(() => [
    { label: "SMTP Mail Host", name: "site_smtp_mail_host", required: true },
    { label: "Port", name: "site_smtp_mail_port", required: true },
    { label: "SMTP Mail Username", name: "site_smtp_mail_username", required: true },
    { label: "SMTP Mail Encryption", name: "site_smtp_mail_encryption", required: true },
    { label: "Site Mail Name", name: "site_smtp_mail_name", required: true },
    { label: "SMTP Mail Address", name: "site_smtp_mail_address", required: true },
    { label: "SMTP Mail Password", name: "site_smtp_mail_password", required: true, type: "password" },
  ], []);

  useEffect(() => {
    smtpFields.forEach(({ name }) => {
      const value = settingData?.[name];
      if (typeof value === "string" || typeof value === "number") {
        setValue(name, value);
      }
    });
  }, [settingData, setValue, smtpFields]);

    useEffect(() => {
    dispatch(fetchSmtpSettings());
  }, [dispatch]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    smtpFields.forEach(({ name }) => {
      if (data[name]) {
        formData.append(name, data[name]);
      }
    });
    
    const result = await dispatch(updateSmtpSettings(formData));
    if (result.payload?.success) {
      dispatch(fetchSmtpSettings());
      navigate('/test-smtp');
      toast.success(t(result.payload.message), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
      });
    }
  };
  if (fetchLoading) {
    return <LoadingScreen loading={true} />;
  }

  return (
    <>
      <PageTitle
        motherMenu={"Settings"}
        activeMenu={"SMTP Settings"}
        customClasses={"mb-0"}
      />
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-2 mb-3 mt-0">
              <SubmitButton
                isLoading={submitLoading}
                form="submit-form"
              />
              <Link
                to="/test-smtp"
                className="btn btn-primary mx-2"
                disabled={submitLoading}
              >
                {t("Test Settings")}
              </Link>
            </div>

            <div className="card">
              <h5 className="card-title p-4">{t("SMTP Settings")}</h5>
              <div className="card-body">
                <div className="row">
                  {smtpFields.map(({ label, name, required, type }) => (
                    <div className="col-md-6" key={name}>
                      <FormField
                        label={label}
                        name={name}
                        register={register}
                        required={required}
                        errors={errors}
                        type={type || "text"}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}


export default SmtpSettingsForm;